import PropTypes from 'prop-types';
import { Box, FormControl, FormControlLabel, Radio, RadioGroup as MuiRadioGroup, Stack } from '@mui/material';

import { InfoTooltip } from 'components/simple';
import { RadioCheckedIcon, RadioUncheckedColoredIcon, RadioUncheckedIcon } from 'assets/icons';

const styles = {
  formControlLabel: ({ palette }) => ({
    '.MuiFormControlLabel-label.Mui-disabled': {
      color: palette.text.primary,
    },
  }),
  radio: ({ palette }) => ({
    paddingRight: 2,
    '&.Mui-disabled': {
      opacity: 0.5,
      '&.Mui-checked': {
        color: palette.primary.main,
      },
    },
  }),
  radioUncheckedIcon: ({ palette }) => ({
    color: palette.colors.darkPale,
  }),
};

export const RadioGroup = ({
  innerRef = null,
  options,
  onChange = () => {},
  value = null,
  labelTypographyProps = {},
  isColored = false,
  ...props
}) => {
  const { variant = 'body2', ...typographyProps } = labelTypographyProps;

  return (
    <FormControl>
      <MuiRadioGroup ref={innerRef} {...props} value={value} onChange={(event, updatedValue) => onChange(updatedValue)}>
        {options.map(({ labelDescription, id, ...option }) => (
          <Stack direction="row" spacing={1} alignItems="center" key={option.value}>
            <FormControlLabel
              {...option}
              sx={styles.formControlLabel}
              slotProps={{
                typography: { variant, ...typographyProps },
              }}
              control={
                <Radio
                  disableRipple
                  icon={
                    <Box
                      component={isColored ? RadioUncheckedColoredIcon : RadioUncheckedIcon}
                      sx={styles.radioUncheckedIcon}
                    />
                  }
                  checkedIcon={<RadioCheckedIcon />}
                  inputProps={{ id: `${id}-radio` }}
                  sx={styles.radio}
                />
              }
            />

            {labelDescription && <InfoTooltip titleText={labelDescription} />}
          </Stack>
        ))}
      </MuiRadioGroup>
    </FormControl>
  );
};

RadioGroup.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  innerRef: PropTypes.func,
  labelTypographyProps: PropTypes.shape({
    variant: PropTypes.string,
  }),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      labelDescription: PropTypes.string,
      value: PropTypes.string.isRequired,
      disabled: PropTypes.bool,
    }),
  ).isRequired,
  isColored: PropTypes.bool,
};
